import AwarenessTooltip from '@Containers/app/tool-tips/awareness-tooltip';
import CriticalScanTooltip from '@Containers/app/tool-tips/critical-scan-tooltip';
import DecisionTooltip from '@Containers/app/tool-tips/decision-tooltip';
import ScanFrequencyTooltip from '@Containers/app/tool-tips/scan-frequency-tooltip';
import ScanTimingTooltip from '@Containers/app/tool-tips/scan-timing-tooltip';

const getMetricTooltip = (metricName: string) => {
    switch(metricName.toUpperCase()) {
      case 'SCAN_FREQUENCY':
        return <ScanFrequencyTooltip />;
      case 'SCAN_TIMING':
        return <ScanTimingTooltip />;
      case 'DECISION':
          return <DecisionTooltip />;
      case 'AWARENESS':
        return <AwarenessTooltip />;
      case 'CRITICAL_SCAN':
          return <CriticalScanTooltip />;
      default:
        return null;
    }
}

export default getMetricTooltip;